import Tariff from '@/classes/Tariff';
class TariffCollection {
    tariffs = [];
    assignedBackgrounds = [];
    colorIndex = 0;
    convertFromJson(tariffJson) {
        const tariffArray = [];
        tariffJson.forEach((tariff) => {
            const tempTariff = new Tariff(tariff);
            tariffArray.push(tempTariff);
        });
        this.tariffs = tariffArray;
    }
    getTariffFromId(id) {
        if (this.tariffs.length > 0) {
            const returnTariff = this.tariffs.filter((object) => (object.id === id));
            return returnTariff[0];
        }
    }
    getCustomerNames() {
        const temp = [...new Set(this.tariffs.map((x) => x.customerName))];
        return temp;
    }
    getTariffsFromCustomerName(name) {
        const filtered = this.tariffs.filter((tariff) => {
            return tariff.customerName === name;
        });
        return filtered;
    }
    getColor(tariffId) {
        const backgrounds = [
            { bg: { backgroundImage: 'linear-gradient(60deg, #26c6da, #00acc1)' }, border: { borderColor: '#26c6da' } },
            { bg: { backgroundImage: 'linear-gradient(60deg, #34495e,  #2c3e50)' }, border: { borderColor: '#34495e' } },
            { bg: { backgroundImage: 'linear-gradient(60deg, #1abc9c,  #16a085)' }, border: { borderColor: '#1abc9c' } },
            { bg: { backgroundImage: 'linear-gradient(60deg, #f1c40f,  #f39c12)' }, border: { borderColor: '#f1c40f' } },
            { bg: { backgroundImage: 'linear-gradient(60deg, #e67e22,  #d35400)' }, border: { borderColor: '#e67e22' } },
            { bg: { backgroundImage: 'linear-gradient(60deg, #9b59b6, #8e44ad)' }, border: { borderColor: '#9b59b6' } },
            { bg: { backgroundImage: 'linear-gradient(60deg, #2ecc71,  #27ae60)' }, border: { borderColor: '#2ecc71' } }, //green
        ];
        const fullName = tariffId;
        const filteredList = this.assignedBackgrounds.filter((object) => (object.name === fullName));
        const exists = filteredList.length;
        if (exists < 1) {
            this.assignedBackgrounds.push({ name: fullName, value: backgrounds[this.colorIndex] });
            const retVal = backgrounds[this.colorIndex];
            if (this.colorIndex === (backgrounds.length - 1)) {
                this.colorIndex = 0;
            }
            else {
                this.colorIndex += 1;
            }
            return retVal;
        }
        else {
            return filteredList[0].value;
        }
    }
}
export default TariffCollection;
